


export interface TourPreference {
  tourCode: string;
  isDismissed: boolean;
  lastSeenStep: number;
  dismissedAt: string | null;
}

const STORAGE_KEY = "tour_preferences";

export const getLocalTourPreferences = (): TourPreference[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as TourPreference[]) : [];
  } catch {
    return [];
  }
};

export const setLocalTourPreference = (pref: TourPreference): void => {
  try {
    const current = getLocalTourPreferences();
    const index = current.findIndex((p) => p.tourCode === pref.tourCode);
    if (index >= 0) {
      current[index] = pref;
    } else {
      current.push(pref);
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  } catch {
    // silent fail
  }
};